import { OrganizationOverviewData } from "@/shared/types/overviewTypes";
import { monthKeyFromStartDate } from "@/domains/global-dashboard/utils/chart-utils";

/** Raw usage for one reporting month (GB as returned by API). */
export type DatapoolMonthSnap = {
  contractedGb: number;
  consumedGb: number;
  cappedForecastGb: number;
  uncappedForecastGb: number;
};

/** Get the datapool snapshot by month for an account. */
export function datapoolSnapshotByYm(organization: OrganizationOverviewData): Map<string, DatapoolMonthSnap> {
  const map = new Map<string, DatapoolMonthSnap>();
  if (!organization.summary?.length) return map;
  for (const row of organization.summary) {
    const dataPoolSnapshot: DatapoolMonthSnap = {
      contractedGb: row.usageSummary?.contractedDatapool ?? 0,
      consumedGb: row.usageSummary?.totalDataUsageGB ?? 0,
      cappedForecastGb: row.usageSummary?.cappedForecastGB ?? 0,
      uncappedForecastGb: row.usageSummary?.uncappedForecastGB ?? 0,
    };
    map.set(monthKeyFromStartDate(row.startDate), dataPoolSnapshot);
  }
  return map;
}
